var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col d-none d-sm-block"}),_c('div',{staticClass:"col-12 col-10-sm col-md-8",attrs:{"id":"stepBody","role":"main"}},[_c('stepheader-view'),_c('router-view'),_c('bottomnav-view')],1),_c('div',{staticClass:"col d-none d-sm-block"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }